var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Historial de Coins","storeName":"Coins_refunds","label-show":"Ver","canAdd":false,"canEdit":false,"canShow":true,"canDelete":false,"filters":_vm.filters,"sortable":"","canSearch":"","next-link":"/admin/notifications_cms","breadcrumbs":[
  {
  text: 'Finanzas',
  disabled: false,
  href: '/admin/coins_refunds'
  },
  {
  text: 'Carga de coins',
  disabled: false,
  href: '#'
  }
  ]},scopedSlots:_vm._u([{key:"user",fn:function({ item }){return [_vm._v(" "+_vm._s(item.user_id?.name)+" "+_vm._s(item.user_id?.last_name)+" ")]}},{key:"user_enterprise",fn:function({ item }){return [_vm._v(" "+_vm._s(item.user_enterprise_id?.name || item.user_enterprise_id)+" ")]}},{key:"coins",fn:function({ item }){return [_c('p',{staticClass:"mb-0 text-no-wrap"},[_vm._v(" "+_vm._s(item.coins)+" ")])]}},{key:"comments",fn:function({ item }){return [_vm._v(" "+_vm._s(item.comments)+" ")]}},{key:"createdAt",fn:function({ item }){return [_vm._v(" "+_vm._s(_vm.formatDate(item.createdAt))+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }